import React from 'react';
import PropTypes from 'prop-types';

import {
  WrapperResultItem,
  WrapperImage,
  WrapperHeader,
  WrapperBody,
  ResultTitle,
  StyledDateFormat,
  StyledDateContainer,
  ResultParagraph,
  WrapperIcon
} from './style';

import Icon from '../Icon';

import { Calendar } from '../../../../assets/images';

/** Components */
import Thumbnail from '../../views/SearchModal/Thumbnail';

const EventItem = ({
  className,
  imgSrc,
  title,
  date,
  dateEnd,
  text,
  urlLink,
  onClick
}) => (
  <WrapperResultItem className={className} to={urlLink} onClick={onClick}>
    {imgSrc && (
      <WrapperImage>
        <Thumbnail path={imgSrc} alt={title} />
      </WrapperImage>
    )}
    <WrapperBody>
      <WrapperHeader>
        <WrapperIcon>
          <Icon svg={Calendar} size="m" hover />
        </WrapperIcon>
        <div>
          <ResultTitle>{title}</ResultTitle>
          <StyledDateContainer>
            Desde <StyledDateFormat format="DD/MM/YY">{date}</StyledDateFormat>{' '}
            hasta{' '}
            <StyledDateFormat format="DD/MM/YY">{dateEnd}</StyledDateFormat>
          </StyledDateContainer>
        </div>
      </WrapperHeader>
      {text && (
        <div>
          <ResultParagraph maxlength={140} text={text} />
        </div>
      )}
    </WrapperBody>
  </WrapperResultItem>
);

EventItem.propTypes = {
  className: PropTypes.string,
  urlLink: PropTypes.string,
  imgSrc: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  dateEnd: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func
};

EventItem.defaultProps = {
  urlLink: '/'
};

export default EventItem;
